export default {"src":"/_next/static/media/CoachTalks_Logo.c926b95d.svg","height":273,"width":595,"blurWidth":0,"blurHeight":0};